import { Prisma } from "@prisma/client";

export const posterStyleValues =
  Prisma.validator<Prisma.PosterStyleDefaultArgs>()({
    select: {
      id: true,
      name: true,
      description: true,
    },
  });

export type PosterStyle = Prisma.PosterStyleGetPayload<
  typeof posterStyleValues
>;

export const defaultPosterStyleValues: PosterStyle = {
  id: "",
  name: "",
  description: "",
};
